/**
 * Convert react router path into regex
 */
export function routeToRegexp(route: string) {
  route = route.replace(/:\w+/g, '([a-z0-9_-]+)').replace(/\//g, '\\/')
  route = '^' + route + '$'

  return new RegExp(route)
}
